export const parseVitalProgramConfigurationValue = (val: string) => {
  try {
    const parsedJSON = JSON.parse(val);

    if (!("programs" in parsedJSON)) {
      return { programs: [] };
    }

    if (!Array.isArray(parsedJSON.programs)) {
      return { programs: [] };
    }

    const validPrograms = parsedJSON.programs.filter((program: unknown) => {
      if (typeof program !== "object" || program === null) {
        return false;
      }

      if (!("title" in program) || typeof program.title !== "string") {
        return false;
      }

      if (!("configurationIds" in program) || !Array.isArray(program.configurationIds)) {
        return false;
      }

      if (!program.configurationIds.every((id) => typeof id === "string" && !!id)) {
        return false;
      }

      return true;
    });

    return {
      programs: validPrograms as { title: string; configurationIds: string[] }[],
    };
  } catch {
    return { programs: [] };
  }
};
